/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
// import DTOActionRequiredMenus from './DTOActionRequiredMenus';
import ActionRequiredMenusPresenter from './ActionRequiredMenusPresenter';
import { useAppDispatch } from '../../../infra/hooks';
import { useTranslation } from 'react-i18next';
import {
  setAREventName,
  setARValue,
} from '../../../infra/aggregates/actionRequired/actionRequiredSlice';

function ActionRequiredMenusController() {
  const dispatch = useAppDispatch();

  const { t, i18n } = useTranslation();

  function handleSetActionRequiredSelectedValue(data: any) {
    if (data) {
      dispatch(setARValue(data?.menu));
      dispatch(setAREventName(data?.eventName));
    }
  }

  const all_menus = [
    { id: 1, name: 'Leave and Leave Advance', eventName: 'leave' },
    { id: 2, name: 'Leave Encashment', eventName: 'leave encashment' },
    { id: 3, name: 'Promotions', eventName: 'promotions' },
    { id: 4, name: 'Award', eventName: 'award' },
    { id: 7, name: 'Transfer', eventName: 'transfer' },
    { id: 8, name: 'Resignation', eventName: 'resignation' },
    { id: 9, name: 'Termination', eventName: 'termination' },
    { id: 10, name: 'Warning', eventName: 'warning' },
    { id: 11, name: 'Complaint', eventName: 'complaint' },
    { id: 12, name: 'Employee Ticket', eventName: 'employeeTicket' },
    { id: 13, name: 'Claims', eventName: 'claims' },
    { id: 14, name: 'Overtime', eventName: 'overtime' },
    { id: 15, name: 'Payroll Settlement', eventName: 'payrollSettlement' },
    { id: 16, name: 'Off-Cycle', eventName: 'offCycle' },
    { id: 17, name: 'Recurring Payment', eventName: 'recurringPayment' },
    { id: 18, name: 'Salary Adjustment', eventName: 'salaryAdjustment' },
    { id: 19, name: 'Set Salary', eventName: 'setSalary' },
    { id: 21, name: 'FnF', eventName: 'fnf' },
    { id: 22, name: 'Letter Request', eventName: 'letter request' },
    { id: 23, name: 'Comp Off', eventName: 'Comp Off' },
  ];
  return (
    <div>
      {/* <DTOActionRequiredMenus /> */}
      <ActionRequiredMenusPresenter
        all_menus={all_menus}
        trans={t}
        i18n={i18n}
        callBackArValue={handleSetActionRequiredSelectedValue}
      />
    </div>
  );
}

export default ActionRequiredMenusController;
